import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import dict from './modules/dict'
import user from './modules/user'
import tagsView from './modules/tagsView'
import permission from './modules/permission'
import settings from './modules/settings'
import getters from './getters'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
const modulesFiles = require.context('./modules', true, /\.js$/)

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
const store = new Vuex.Store({
  modules,
  getters
})
 
export default store
// const store = new Vuex.Store({
//   modules: {
//     app,
//     dict,
//     user,
//     tagsView,
//     permission,
//     settings
//   },
//   getters,
//   plugins: [
//     createPersistedState({
//       reducer(val) {        
//         return {          
//             // 只存储state中的user        
//             user: val.user,
//             topbarRouters:val.permission.topbarRouters
//         }      
//     } 
//     })
//   ]
// })

// export default store
